import React from "react";
import { TCriteriaItem, TCrits } from "../../store/types";
import capitalize from "lodash/capitalize";
import "./AccommodationHighlights.scss";
import { Col, Row } from "react-bootstrap";
import classNames from "classnames";
import useAppSelector from "../../hooks/useAppSelector";
import { optionsSelector } from "../../Selectors";
import { convertCriteriaToInterval } from "../../Helper";

type TAccommodationHighlights = {
    criterias: TCriteriaItem[];
    criteriaValues: TCrits;
};

export const AccommodationHighlights = ({ criterias, criteriaValues }: TAccommodationHighlights) => {
    const useCriteriaInterval = useAppSelector(optionsSelector).use_interval_distance_criterias;
    // Only criterias that exists on the product.
    const criteriasToDisplay = criterias.filter(criteria => criteria.code in criteriaValues);

    const getCriteriaValue = (value: any, criteria: TCriteriaItem): string => {
        if (criteria.type === "MAX" && useCriteriaInterval) {
            const interval = convertCriteriaToInterval(value, criteria.typeunit);

            if (interval.startUnit === interval.endUnit) {
                return `${interval.startValue}-${interval.endValue} ${interval.startUnit}`.trim();
            } else {
                return `${interval.startValue} ${interval.startUnit}-${interval.endValue} ${interval.endUnit}`.trim();
            }
        } else {
            return `${value} ${criteria.typeunit}`.trim();
        }
    };

    if (criteriasToDisplay.length === 0) return null;

    return (
        <Row
            className={classNames("row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-3 row-cols-xl-5", {
                "accommodation-highlights": criteriasToDisplay.length < 5 || criteriasToDisplay.length > 2,
                "accommodation-highlights-multiple": criteriasToDisplay.length >= 5 || criteriasToDisplay.length <= 2,
            })}
            as="dl"
        >
            {criteriasToDisplay.map(criteria => {
                const value = criteriaValues[criteria.code];
                return (
                    <Col className="accommodation-highlight" key={criteria.code}>
                        <dt className="accommodation-highlight__title">
                            {capitalize(criteria.title.toLocaleLowerCase())}
                        </dt>
                        <dd className="accommodation-highlight__value">{getCriteriaValue(value, criteria)}</dd>
                    </Col>
                );
            })}
        </Row>
    );
};
